import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

const schema = yup.object().shape({
  tenant_url: yup.string().required("Tenant URL is required"),
  client_id: yup.string().required("Client ID is required"),
  client_secret: yup.string().required("Client Secret is required"),
});

function OneTrustConnectForm({ onSubmit, guideMode, savedFormValues }) {
  const [showSecret, setShowSecret] = useState(false);
  const handleClickShowSecret = () => setShowSecret(!showSecret);
  const handleMouseDownSecret = (e) => e.preventDefault();

  const formInitialValues = savedFormValues?.credentials || {
    tenant_url: "",
    client_id: "",
    client_secret: "",
  };

  const handleFormSubmit = (values) => {
    onSubmit({ credentials: values });
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={schema}
        enableReinitialize
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="tenant_url"
                label="Tenant URL (e.g. your-company.my.onetrust.com)"
                placeholder="your-company.my.onetrust.com"
                value={values.tenant_url}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.tenant_url && !!errors.tenant_url}
                helperText={touched.tenant_url && errors.tenant_url}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="client_id"
                label="Client ID"
                placeholder="Enter your OneTrust Client ID"
                value={values.client_id}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.client_id && !!errors.client_id}
                helperText={touched.client_id && errors.client_id}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                type={showSecret ? "text" : "password"}
                name="client_secret"
                autoComplete="off"
                label="Client Secret"
                placeholder="Enter your OneTrust Client Secret"
                value={values.client_secret}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.client_secret && !!errors.client_secret}
                helperText={touched.client_secret && errors.client_secret}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle secret visibility"
                        onClick={handleClickShowSecret}
                        onMouseDown={handleMouseDownSecret}
                      >
                        {showSecret ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}

export default OneTrustConnectForm;
